var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error-view',{attrs:{"error-type":"no-permissions"}})
}
var staticRenderFns = []

export { render, staticRenderFns }